import { render, staticRenderFns } from "./ContactCard.vue?vue&type=template&id=cf2c19ea&scoped=true"
import script from "./ContactCard.vue?vue&type=script&lang=ts"
export * from "./ContactCard.vue?vue&type=script&lang=ts"
import style0 from "./ContactCard.vue?vue&type=style&index=0&id=cf2c19ea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf2c19ea",
  null
  
)

export default component.exports